module.exports = __webpack_public_path__ + "img/envelope.c7154929.svg";